import { FlightEventHandler } from './flight'
import { writable } from 'svelte/store'

export default class ReplayTimeline extends FlightEventHandler {

	endedTime = null

	constructor(flight) {
		super(flight)

		const { subscribe, set } = writable(null);
		this.subscribe = subscribe
		this.set = set
	}

	handleKeyframe(keyframe) {
		if (!this.endedTime || this.endedTime < keyframe.end) {
			this.endedTime = keyframe.end
			this.set(this.endedTime)
		}
	}
	
	percentToTime(percent) {
		percent = Math.max(0, Math.min(1, percent));

		const start = new Date(this.flight.liveServerState.startedTime).getTime();
		let end;
		if (this.flight.liveServerState.state === 'ENDED') {
			end = this.endedTime;
		} else {
			end = Date.now();
		}

		return start + (end - start) * percent;
	}

	timeToPercent(timestamp, liveTimestamp) {
		const start = new Date(this.flight.liveServerState.startedTime).getTime();
		let end;
		if (this.flight.liveServerState.state === 'ENDED') {
			end = this.endedTime;
		} else {
			end = liveTimestamp
		}

		let percent = (timestamp - start) / (end - start);

		return Math.max(0, Math.min(1, percent));
	}

}
